module.exports = __webpack_public_path__ + "img/symbol_7.d3ac8379.png";